import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { get } from 'lodash';
import { useParams } from 'react-router';

import { Textarea, FormField, useEnhancedFormik, IconButton } from '@mssgme/ui';
import { DeprecatedSaveIcon, DeprecatedTrashIcon } from '@mssgme/icons';
import { useFetching } from '@mssgme/hooks';

import QuickRepliesDialog from './QuickRepliesDialog';
import { replyType } from './QuickReplyItem';
import useQuickReplyEdit from './useQuickReplyEdit';

// import styles from './QuickReplyEdit.scss';

PureQuickReplyEdit.propTypes = {
    data: replyType,
    onSubmit: PropTypes.func,
    onRemove: PropTypes.func,
    onClose: PropTypes.func,
};

export function PureQuickReplyEdit({ data, onSubmit, onRemove, onClose, ...rest }) {
    const { t } = useTranslation('inbox');
    const remove = useFetching(onRemove);

    const formik = useEnhancedFormik({
        initialValues: {
            shortcut: get(data, 'shortcut', ''),
            message: get(data, 'message', ''),
        },
        enableReinitialize: true,
        onSubmit,
    });

    if (formik.status === 'success' || remove.fulfilled) {
        onClose && onClose();
    }

    const isNew = !(data && data._id);
    const title = isNew ? t('QuickReplyEditPopup.title') : data.shortcut;
    const buttons = (
        <>
            {formik.dirty && (
                <IconButton onClick={formik.submitForm}>
                    <DeprecatedSaveIcon size={22} title={t('ui:button.save')} />
                </IconButton>
            )}
            {!isNew && (
                <IconButton color="#dc5960" onClick={() => remove.run()}>
                    <DeprecatedTrashIcon size={22} title={t('ui:button.remove')} />
                </IconButton>
            )}
        </>
    );

    return (
        <QuickRepliesDialog title={title} buttons={buttons} onClose={onClose} {...rest}>
            <form onSubmit={formik.handleSubmit}>
                <FormField
                    label={t('QuickReplyEditPopup.shortcut.label')}
                    placeholder={t('QuickReplyEditPopup.shortcut.placeholder')}
                    maxLength={20}
                    errors={formik.errors.shortcut}
                    {...formik.getFieldProps('shortcut')}
                />
                <FormField
                    component={Textarea}
                    label={t('QuickReplyEditPopup.message.label')}
                    placeholder={t('QuickReplyEditPopup.message.placeholder')}
                    maxLength={2000}
                    errors={formik.errors.message}
                    {...formik.getFieldProps('message')}
                />
            </form>
        </QuickRepliesDialog>
    );
}

export default function QuickReplyEdit(props) {
    const { replyId } = useParams();
    const state = useQuickReplyEdit(replyId);

    return <PureQuickReplyEdit {...state} {...props} />;
}
